<template>
  <div class="asset-contract-copy-tool">
    <b-field grouped style="margin-bottom: 0">
      <base-select
        v-model="contractSelected"
        :service="$options.contractService"
        fetch-func="all"
        :fetch-params="{
          type_tag_id: contract.type_tag_id,
          includes: 'contractor',
        }"
        :custom-filter="filterContracts"
        message="Assets from the selected contract will be copied."
        :disabled="loading || processing"
      >
        <template #customLabel="{ option }">
          {{ `${option.contractor.name} - ${option.name}` }}
        </template>
      </base-select>
      <p class="control">
        <b-button
          label="COPY"
          :loading="loading || processing"
          :disabled="!contractSelected || processing"
          @click="copy"
        />
      </p>
    </b-field>
    <span class="tag is-info" v-if="processing"
      >Currently processing request...</span
    >
  </div>
</template>

<script>
import BaseSelect from "@/components/partials/BaseSelect";
import { ContractService } from "@/services/contract.service";

export default {
  contractService: ContractService,
  props: {
    contract: {
      type: Object,
      required: true,
    },
  },
  components: {
    BaseSelect,
  },
  data: () => ({
    contractSelected: null,
    statusInterval: null,
    processing: false,
    loading: false,
  }),
  mounted() {
    this.checkStatus();
    this.statusInterval = setInterval(this.checkStatus, 5000);
  },
  beforeDestroy() {
    if (this.statusInterval) {
      clearInterval(this.statusInterval);
    }
  },
  methods: {
    async copy() {
      if (!this.contractSelected && !this.processing) return;
      try {
        this.loading = true;
        await ContractService.copyAssets(this.contract.id, {
          from_contract_id: this.contractSelected,
        });
        this.processing = true;
        this.$buefy.toast.open({
          message: "Copy request has been queued for processing.",
          type: "is-info",
          position: "is-top-right",
        });
      } catch (err) {
      } finally {
        this.loading = false;
      }
    },
    async checkStatus() {
      const status = await ContractService.copyAssetsStatus(
        this.contract.id
      ).then((response) => response.status);
      if (status == "processed") {
        this.processing = false;
      } else {
        this.processing = true;
      }
    },
    filterContracts(contracts) {
      // Remove selected contract (contract prop) from options
      return contracts.filter(contract => contract.id != this.contract.id);
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/Asset/AssetContractCopyTool.vue